import React from "react";
import set from "@rill/set";
import { useTranslation } from "react-i18next";
import SupportNav from "../../../parts/support-nav";

function View(props) {
  const { t } = useTranslation("dashboard");
  return (
    <div className="Main Support-FAQ">
      <SupportNav />

      <div className="Content">
        <div className="FAQs">
          <div className="item">
            <input type="checkbox" id="question-1" />
            <div className="question">
              <label className="expand-toggle" htmlFor="question-1" />
              {t("supportFaq.question")}
            </div>
            <div className="answer">{t("supportFaq.placeholderAnswer")}</div>
          </div>

          <div className="item">
            <input type="checkbox" id="question-2" />
            <div className="question">
              <label className="expand-toggle" htmlFor="question-2" />
              {t("supportFaq.question")}
            </div>
            <div className="answer">{t("supportFaq.placeholderAnswer")}</div>
          </div>

          <div className="item">
            <input type="checkbox" id="question-3" />
            <div className="question">
              <label className="expand-toggle" htmlFor="question-3" />
              {t("supportFaq.question")}
            </div>
            <div className="answer">{t("supportFaq.placeholderAnswer")}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Faq = (app) => {
  app.get(
    "/faq",
    set("heading", "Frequently Asked Questions"),
    ({ res }) => (res.body = <View />)
  );
};

export default Faq;
